/**
 * Copyright 2019-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';
import { Component } from 'react';
import { Accordion } from 'react-bootstrap';
import './DetailAccordionCard.scss';
export interface DetailAccordionCardProps {
  eventKey: string;
  title: string;
  isExpanded?: boolean;
}

export interface DetailAccordionCardState {
  expanded: boolean;
}

export default class DetailAccordionCard extends Component<DetailAccordionCardProps, DetailAccordionCardState> {
  constructor (props : DetailAccordionCardProps) {
    super(props);
    this.state = {
      expanded: !!props.isExpanded
    };
  }

  render () {
    return (
      <Accordion.Item eventKey={this.props.eventKey}>
        <Accordion.Button className="link shadow-none">
          <h4>{this.props.title}</h4>
        </Accordion.Button>
        <Accordion.Body>
          {this.props.children}
        </Accordion.Body>
      </Accordion.Item>
    );
  }
}
